import './polyfils.js';
import "babel-polyfill";

import React from 'react';
import ReactDOM from 'react-dom';

import Overview from './js/overview/components/overview.component';

import './css/overview.css';

const url = window.location.pathname;
if (/\/view\/(?!$)/.test(url) && url.indexOf("/view/") !== -1) {
    let pID = window.location.pathname.replace(/\/?$/, "").split("/").reverse()[0];
    window.location.replace(window.location.origin+'/studio.html?p='+pID);
}

ReactDOM.render(
    <Overview />,
    document.getElementById('overview-root')
);


// WEBPACK FOOTER //
// ./src/index.js